<template>
	<div
			class="language"
			:class="{ active: languageMenuOpen }"
			@click="languageMenuOpen = !languageMenuOpen"
	>
		<span name="language">{{ $language.current }}</span>
		<ul>
			<li v-for="language in languagesToSelect"><a @click="setLanguage(language)">{{ language }}</a></li>
		</ul>
	</div>
</template>

<script>
import {SET_LANGUAGE} from "../../store/mutation-types"

export default {
	name: "LanguageSelect",
	data() {
		return {
			languageMenuOpen: false,
		}
	},
	computed: {
		languagesToSelect() {
			let languagesToSelect = {}
			Object.assign(languagesToSelect, this.$language.available)
			delete languagesToSelect[this.$language.current]
			return languagesToSelect
		}
	},
	methods: {
		setLanguage(language) {
			this.$language.current = language
			this.$store.dispatch(SET_LANGUAGE, language)
      $('.datepicker').datepicker('option', $.datepicker.regional[language.toLowerCase()]);
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/LanguageSelect.vue